import React from 'react';
import styled from 'styled-components';

interface GradientButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  startIcon?: React.ReactNode;
  style?: React.CSSProperties;
}

const StyledButton = styled.button<{ disabled?: boolean }>`
  background: ${props => props.disabled ? '#A0AEC0' : 'linear-gradient(90deg, #8B5CF6 0%, #3B82F6 100%)'};
  border: none;
  border-radius: 9999px;
  color: white;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 18px;
  font-weight: bold;
  padding: 16px 32px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: ${props => props.disabled ? 'none' : 'translateY(-2px)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)'};
  }

  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(1px)'};
  }

  &::before {
    content: '✦';
    margin-right: 8px;
  }

  &::after {
    content: '✦';
    margin-left: 8px;
  }
`;

const IconWrapper = styled.span`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

const GradientButton: React.FC<GradientButtonProps> = ({ onClick, children, style, disabled = false, startIcon }) => {
  return (
    <StyledButton onClick={onClick} disabled={disabled}>
      {startIcon && <IconWrapper>{startIcon}</IconWrapper>}
      {children}
    </StyledButton>
  );
};

export default GradientButton;